import React from "react";
import UploadCloudImg from "../icons/upload-cloud.svg";

const UploadCloudIcon = ({ disabled }) => {
  return (
    <img
      src={UploadCloudImg}
      alt="upload"
      style={{
        height: "20px",
        width: "20px",
        filter: disabled
          ? "grayscale(100%) brightness(70%)" // greyed-out look
          : "",
        transition: "filter 0.2s ease",
      }}
    />
  );
};


export default UploadCloudIcon;
